<template>
    <div class="wrapper">
        <div class="tit">
            <h1>Bienvenid@ {{getUser.name}}</h1>
        </div>
    </div>
</template>
<script>

    import {mapGetters} from 'vuex'

    export default {
        components: {},
        data() {
            return {}
        },
        computed: {
            ...mapGetters([
                'getUser'
            ]),
        },
        methods: {},
        async mounted() {


        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Index.vue